export const restoreTimeConstants = {
    //GET Database restore time
    GET_RESTORE_DATE_REQUEST: 'REPORT_RESTORE_DATE_TIME_REQUEST',
    GET_RESTORE_DATE_SUCCESS: 'REPORT_RESTORE_DATE_TIME_SUCCESS',
    GET_RESTORE_DATE_FAILURE: 'REPORT_RESTORE_DATE_TIME_FAILURE',
}